export default __webpack_public_path__ + "static/calibrate-49631a0116c1ad2ffc6431cafabfc153.mp4";